import { INCOME_TYPE } from 'services/cash-flow/income/types';
import { ISettlementPeriodName } from 'services/label-report/types';
import {
  EMAIL_SEND,
  IInfinitePageParams,
  IInfinitePageResponse,
  IInfinitePageStatisticsResponse,
} from 'services/types';

export interface ISettlementResponse {
  id: string;
  labelId: string;
  labelName?: string;
  settlementNumber: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  startSettlementPeriodDate: string;
  endSettlementPeriodDate: string;
  fileId: string;
  filePath: string | null;
  sendStatus: EMAIL_SEND;
  netAmount: number;
  startSettlementPeriodName: ISettlementPeriodName | null;
  endSettlementPeriodName: ISettlementPeriodName | null;
}

export interface ISettlementLabelResponse extends ISettlementResponse {}

export interface ISettlementLabelStatistics {
  allNetAmount: number;
}

export interface ISettlementStatistics extends ISettlementLabelStatistics {}

export interface ISettlementLabelPageResponse
  extends IInfinitePageStatisticsResponse<
    ISettlementLabelResponse,
    ISettlementLabelStatistics
  > {}

export interface ISettlementPageResponse extends ISettlementLabelPageResponse {}

export interface IGetSettlementLabelInfiniteParams extends IInfinitePageParams {
  StartSettlementPeriodId?: string;
  EndSettlementPeriodId?: string;
}

interface Amount {
  grossAmount: number;
  netAmount: number;
}

export interface IFinancesDetail {
  id: string;
  name: string;
  amountToRepayment: number;
  tax: number;
  fileUrl: string | null;
  amount: Amount;
  type: BALANCE_TYPE;
  incomeType: INCOME_TYPE;
}

export interface ResponseHandlerResult
  extends IInfinitePageResponse<IFinancesDetail> {}

export interface ISettlementTimeline {
  settlementPeriodId: string;
  settlementPeriodName: string;
  settlementPeriodYear: number;
  startDate: string;
  endDate: string;
  isSettled: boolean;
}

export enum BALANCE_TYPE {
  income = 0,
  cost = 1,
}
